/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { timeout } from 'ember-concurrency';
import { ONE_MINUTE_IN_MILLISECONDS } from 'cio/utils/time-constants';
import Ember from 'ember';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import SqlImportModel from 'cio/models/sql-import';
import SqlImportRowModel from 'cio/models/sql-import-row';

interface SqlImportsImportDetailsArgs {
  model: SqlImportModel;
  readonly: boolean;
}

export default class SqlImportsImportDetails extends Component<SqlImportsImportDetailsArgs> {
  @service auth!: AuthService;

  tooltipText = `You must have Workspace manager permissions (or greater) 
    to manage syncs. Contact your workspace admin to increase your permissions.`;

  pollForImportsTask = task(async () => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      let rows = (await this.args.model.hasMany('sqlImportRows').reload()) as SqlImportRowModel[];

      if (Ember.testing) {
        break;
      }

      let hasRowsInProgress = rows.find((row) => row.isPending);
      // If there are imports in progress, query more often.
      await timeout(hasRowsInProgress ? ONE_MINUTE_IN_MILLISECONDS / 2 : ONE_MINUTE_IN_MILLISECONDS);
    }
  });
}
